import React from "react";

import type { ChatMention } from "@/features/chat/shared/types";
import { parseMentions } from "@/features/chat/shared/utils/mention.utils";

import * as styles from "./mention-text.css";

interface MentionTextProps {
  content: string;
  mentions?: ChatMention[];
}

export const MentionText: React.FC<MentionTextProps> = ({
  content,
  mentions
}) => {
  const segments = parseMentions(content, mentions ?? []);

  return (
    <>
      {segments.map((segment, index) =>
        segment.type === "mention" ? (
          <a
            key={index}
            href={segment.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.mentionLink}
          >
            {segment.value}
          </a>
        ) : (
          <React.Fragment key={index}>{segment.value}</React.Fragment>
        )
      )}
    </>
  );
};
